'use client';

import { Box, Flex, Button, HStack } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import type { HexString } from '@/lib/config/wagmi';
import { useHLClearingHouseState } from '@/lib/hooks/useMargin';

interface InfoTabsProps {
  activeTab: string;
  onTabPress: (tabId: string) => void;
  userAddress: HexString;
}

const tabs = [
  { id: 'overview', label: 'Overview' },
  { id: 'portfolio', label: 'Portfolio' },
  // { id: 'position', label: 'Position' },
  // { id: 'history', label: 'History' },
];

export function InfoTabs({
  activeTab,
  onTabPress,
  userAddress,
}: InfoTabsProps) {
  const t = useTranslations('trader.tabs');

  const { data: clearingHouseState } = useHLClearingHouseState({
    user: userAddress,
  });

  const activePositions =
    clearingHouseState?.assetPositions.filter(
      (assetPosition) => Number.parseFloat(assetPosition.position.szi) !== 0,
    ) || [];

  return (
    <Box bg="black" px={4}>
      <Flex justify="flex-start" overflowX="auto" py={4}>
        <HStack gap={8}>
          {tabs.map((tab) => (
            <Button
              key={tab.id}
              variant="ghost"
              size="sm"
              onClick={() => onTabPress(tab.id)}
              position="relative"
              pb={2}
              fontWeight={activeTab === tab.id ? 'bold' : 'normal'}
              color="white"
              _hover={{
                bg: 'transparent',
                color: activeTab === tab.id ? 'white' : 'gray.400',
              }}
              _after={{
                content: '""',
                position: 'absolute',
                bottom: '-2px',
                left: '50%',
                right: 0,
                width: '16px',
                height: '2px',
                transform: 'translateX(-50%)',
                bg: activeTab === tab.id ? 'white' : 'transparent',
                transition: 'all 0.2s',
              }}
            >
              {t(tab.id as any)}{' '}
              {tab.id === 'portfolio' &&
                activePositions.length > 0 &&
                `(${activePositions.length})`}
            </Button>
          ))}
        </HStack>
      </Flex>
    </Box>
  );
}
